import {FeedbackType} from 'components/FeedbackForm/types';
import {apiMethod, APIService} from 'services/APIService';

export interface SubmitFeedbackData {
  type: FeedbackType;
  message: string;
}

class FeedbackAPI extends APIService {
  submitFeedback = apiMethod(
    (data: SubmitFeedbackData) => this.fetcher.request({
      method: 'POST',
      url: `/api/feedback/`,
      data: {
        ...data
      },
    }),
  );
}

export {FeedbackAPI};
